<script lang="ts">
  import type { Organization } from './api';
  import { updateOrganizationProfile } from './api';

  let { organization, onsaved }: { organization: Organization; onsaved: (organization: Organization) => void } = $props();
  let displayName = $state('');
  let websiteURL = $state('');
  let linkedInPageURL = $state('');
  let saving = $state(false);
  let error = $state('');

  $effect(() => {
    displayName = organization.display_name;
	websiteURL = organization.website_url;
    linkedInPageURL = organization.linkedin_page_url;
  });

  async function save() {
    saving = true;
    error = '';
    try {
		onsaved(await updateOrganizationProfile(displayName, websiteURL, linkedInPageURL));
    } catch (cause) {
      error = cause instanceof Error ? cause.message : 'Could not save organization details.';
    } finally {
      saving = false;
    }
  }
</script>

<form class="profile-form" onsubmit={(event) => { event.preventDefault(); void save(); }}>
  <div class="profile-intro"><p class="eyebrow">credential identity</p><h3>How recipients see you.</h3><p>This name appears inside portable Open Badges and in the copy-ready LinkedIn details. Your Nostr public key remains the cryptographic organization identity.</p></div>
  <label><span>Organization name</span><input bind:value={displayName} maxlength="120" autocomplete="organization" placeholder="Bitcoin++" /></label>
	<label><span>Organization website</span><input bind:value={websiteURL} type="url" inputmode="url" autocomplete="url" placeholder="https://btcpp.dev" /><small>This becomes the issuer link in portable credentials and can be populated from a connected directory.</small></label>
  <label><span>LinkedIn organization page</span><input bind:value={linkedInPageURL} type="url" inputmode="url" autocomplete="url" placeholder="https://www.linkedin.com/company/your-organization" /><small>Use the company or school Page recipients should select as the credential issuer.</small></label>
  {#if error}<p class="error" role="alert">{error}</p>{/if}
  <button type="submit" disabled={saving}>{saving ? 'Saving…' : 'Save credential identity'}</button>
</form>

<style>
  .profile-form { display: grid; grid-template-columns: minmax(240px,.8fr) minmax(300px,1.2fr); gap: 28px 52px; max-width: 940px; padding: clamp(24px,5vw,54px); border: 1px solid var(--line-strong); background: var(--surface); box-shadow: 12px 14px 0 color-mix(in srgb, var(--aqua) 12%, transparent); }
  .profile-intro { grid-row: span 3; }
  .eyebrow { margin: 0 0 12px; color: var(--violet); font-size: 10px; font-weight: 850; letter-spacing: .15em; }
  h3 { margin: 0; font-family: var(--display); font-size: clamp(30px,4vw,46px); font-weight: 500; letter-spacing: -.04em; line-height: .95; }
  p { color: var(--muted); font-size: 14px; line-height: 1.55; }
  label { display: grid; gap: 8px; align-content: start; font-size: 12px; font-weight: 800; }
  input { width: 100%; min-height: 48px; box-sizing: border-box; border: 1px solid var(--line-strong); border-radius: 0; background: var(--paper); padding: 11px 13px; color: var(--ink); font: 14px var(--sans); }
  input:focus { outline: 3px solid color-mix(in srgb, var(--aqua) 28%, transparent); outline-offset: 2px; }
  small { color: var(--muted); font-size: 11px; font-weight: 500; line-height: 1.45; }
  button { justify-self: start; min-height: 46px; border: 0; padding: 0 19px; background: var(--ink); color: white; font-weight: 800; cursor: pointer; }
  button:disabled { cursor: wait; opacity: .6; }
  .error { grid-column: 2; margin: 0; padding: 10px 12px; border-left: 3px solid var(--coral); background: #f9e4e4; color: #842f38; }
  @media (max-width: 720px) { .profile-form { grid-template-columns: 1fr; padding: 28px var(--mobile-gutter); } .profile-intro { grid-row: auto; } .error { grid-column: auto; } button { width: 100%; } }
</style>
